import { connect } from 'react-redux';
import {
  sendToTourManager,
  requestTourManagers,
 } from '../modules/tour';

import TourManagerModal from './TourManagerModal';

const mapDispatchToProps = {
  sendToTourManager,
  requestTourManagers,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
  tourManagers: state.tours.tourManagers,
});
const TourManagerModalContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourManagerModal);
export default TourManagerModalContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourManagerModalContainer.js